import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["xlink:href"]

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return (_openBlock(), _createElementBlock("svg", {
    "aria-hidden": "true",
    focusable: "false",
    class: _normalizeClass(["o-ico", $props.className])
  }, [
    _createElementVNode("use", { "xlink:href": $options.url }, null, 8 /* PROPS */, _hoisted_1)
  ], 2 /* CLASS */))
}